import { plural } from '@srm/ui/lib/pluralize';
import { IMatrixComplianceAnswer, MatrixCompliance } from '../WinnerSelection2.types';

export const parseQuantityInput = (raw: string): number | null => {
    const text = raw.replace(/\s/g, '').replace(',', '.');
    if (!text) return null;
    const value = Number(text);
    return Number.isFinite(value) ? value : null;
};

/**
 * Ошибка выбранного количества. Больше предложенного участником сервер не
 * сохранит — показываем сразу, остальное — после попытки сохранить.
 */
export const quantityErrorOf = (quantity: number | null, offered: number | null, submitted: boolean) => {
    if (quantity != null && offered != null && quantity > offered)
        return 'Нельзя выбрать больше, чем предложил участник';
    if (submitted && (quantity == null || quantity < 0)) return 'Введите неотрицательное количество';
    return undefined;
};

export const answerOf = (answers: IMatrixComplianceAnswer[], value: string | null | undefined) =>
    answers.find((answer) => answer.value === value);

export const complianceOf = (answers: IMatrixComplianceAnswer[], value: string | null | undefined): MatrixCompliance =>
    value ? (answerOf(answers, value)?.compliance ?? 'unknown') : 'unanswered';

export const commentRequiredFor = (answers: IMatrixComplianceAnswer[], value: string | null | undefined) => {
    const answer = answerOf(answers, value);
    return (
        !!answer && (answer.commentRequired || answer.compliance === 'partial' || answer.compliance === 'noncompliant')
    );
};

export const supplierOffersHint = (count: number) =>
    `Те же ответ и комментарий будут сохранены ещё в ${count} ${plural(count, ['предложении', 'предложениях', 'предложениях'])} этого поставщика`;
